import React, { useState } from "react";
import { Divider, Pagination } from "antd";
import { FaRegCalendarAlt, FaComments, FaChevronDown } from "react-icons/fa";
import AppointmentItem from "./AppointmentItem";
import AppointmentItemCompact from "./AppointmentItemCompact";
import ContactNoteItem from "./ContactNoteItem";

const HistoryTab = ({ notes, page = 1, limit = 10, total = 0, onChangePage, onEditAppointment }) => {
  const [isApptExpanded, setIsApptExpanded] = useState(true);
  const [isNotesExpanded, setIsNotesExpanded] = useState(true);
  const [showAllAppointments, setShowAllAppointments] = useState(false);

  // Filter notes that have next appointment schedule
  const appointmentNotes = (notes || [])
    .filter((item) => item.is_appointment && item.appointment_date)
    .sort((a, b) => new Date(b.appointment_date) - new Date(a.appointment_date));

  // If showAllAppointments is false, show only 1 latest appointment
  const displayedAppointments = showAllAppointments
    ? appointmentNotes
    : appointmentNotes.slice(0, 1);

  return (
    <div className="history-tab-container">
      {/* SECTION 1: การนัดหมาย */}
      <div className="history-section">
        <div
          className="history-section-header cursor-pointer"
          onClick={() => setIsApptExpanded(!isApptExpanded)}
          title={isApptExpanded ? "คลิกเพื่อย่อ" : "คลิกเพื่อขยาย"}
        >
          <div className="history-section-title">
            <FaRegCalendarAlt className="history-section-icon icon-orange" />
            <span className="history-section-heading">การนัดหมาย</span>
            <span className="history-section-count font-orange">({appointmentNotes.length})</span>
          </div>

          <span className={`arrow-icon-transition ${isApptExpanded ? "arrow-icon-rotated" : ""}`}>
            <FaChevronDown style={{ fontSize: "12px", color: "#8c8c8c" }} />
          </span>
        </div>

        {isApptExpanded && (
          <div className="history-section-content">
            {appointmentNotes.length === 0 ? (
              <div className="empty-history-box">ไม่มีรายการนัดหมาย</div>
            ) : (
              <>
                {displayedAppointments.map((item, index) =>
                  index === 0 ? (
                    <AppointmentItem
                      key={item.id}
                      item={item}
                      onEditAppointment={onEditAppointment}
                    />
                  ) : (
                    <AppointmentItemCompact
                      key={item.id}
                      item={item}
                      onEditAppointment={onEditAppointment}
                    />
                  )
                )}

                {/* "ดูประวัติ" toggle button at bottom right if multiple appointments */}
                {appointmentNotes.length > 1 && (
                  <div className="d-flex justify-content-end mt-1 mb-1">
                    <button
                      type="button"
                      className="btn-history-toggle-link"
                      onClick={() => setShowAllAppointments(!showAllAppointments)}
                      style={{
                        background: "none",
                        border: "none",
                        color: "#fa8c16",
                        fontSize: "12px",
                        fontWeight: "600",
                        cursor: "pointer",
                        padding: "2px 4px",
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "4px",
                        borderRadius: "4px",
                      }}
                    >
                      {showAllAppointments ? "ซ่อนประวัติ" : `ดูประวัติ (${appointmentNotes.length})`}
                    </button>
                  </div>
                )}
              </>
            )}
          </div>
        )}
      </div>

      <Divider style={{ margin: "14px 0" }} />

      {/* SECTION 2: บันทึกการติดต่อ */}
      <div className="history-section">
        <div
          className="history-section-header cursor-pointer"
          onClick={() => setIsNotesExpanded(!isNotesExpanded)}
          title={isNotesExpanded ? "คลิกเพื่อย่อ" : "คลิกเพื่อขยาย"}
        >
          <div className="history-section-title">
            <FaComments className="history-section-icon icon-blue" />
            <span className="history-section-heading">บันทึกการติดต่อ</span>
            <span className="history-section-count font-blue">({total || (notes || []).length})</span>
          </div>

          <span className={`arrow-icon-transition ${isNotesExpanded ? "arrow-icon-rotated" : ""}`}>
            <FaChevronDown style={{ fontSize: "12px", color: "#8c8c8c" }} />
          </span>
        </div>

        {isNotesExpanded && (
          <div className="history-section-content">
            {(notes || []).length === 0 ? (
              <div className="empty-history-box">ไม่มีประวัติการบันทึกการติดต่อ</div>
            ) : (
              notes.map((item) => (
                <ContactNoteItem key={item.id} item={item} />
              ))
            )}
          </div>
        )}
      </div>

      {total > limit && (
        <div className="d-flex justify-content-end mt-2 mb-1">
          <Pagination
            size="small"
            current={page}
            pageSize={limit}
            total={total}
            onChange={(p) => onChangePage && onChangePage(p)}
          />
        </div>
      )}
    </div>
  );
};

export default HistoryTab;
